import * as swcHelpers from '@swc/helpers';
import { getPrices } from '../utils/get-prices.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import { mapBundleChildLineItems } from '../utils/map-bundle-child-line-items.js';
import { toBaseLineItem } from './base-line-item.js';

const toNonPrescriptionBundleOrderLineItem = (lineItem, intl, options = {})=>{
    const { originalPrice , discountPrice  } = getPrices(lineItem);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'NON_PRESCRIPTION_BUNDLE',
        productType: 'non-prescription-bundle',
        // originalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        originalPrice: originalPrice || 0,
        // lineItemDiscountedPrice is the price with the discount applied which we show next to the TOTAL PRICE for the entire bundle, including child line items
        discountPrice,
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toNonPrescriptionBundleOrderLineItem };
//# sourceMappingURL=non-prescription-bundle-line-item.js.map
